import { fork, take, call, put } from "redux-saga/effects";
import types from "./types";
import { apiDirect, postAPIWithoutModule } from "../../api/generic";
import { getSubscriptionPlanResp, getTestimonalDataResp } from "./actions";

export function* doGetSubscription() {
  while (true) {
    const { payload } = yield take(types.GET_SUBSCRIPTION);
    const response = yield call(apiDirect, payload);
    yield put(getSubscriptionPlanResp(response));
  }
}

export function* doGetTestimonalData() {
  while (true) {
    const { payload } = yield take(types.GET_TESTIMONAL);
    const response = yield call(postAPIWithoutModule, payload);
    yield put(getTestimonalDataResp(response));
  }
}

function* getRes() {
  yield fork(doGetSubscription);
  yield fork(doGetTestimonalData);
}

export default getRes;
